export const SET_EMAIL_FOR_SHARED_AUTH = 'SET_EMAIL_FOR_SHARED_AUTH';
export const SET_ROLES_FOR_SHARED_AUTH = 'SET_ROLES_FOR_SHARED_AUTH';
export const SET_PERMISSIONS_FOR_SHARED_AUTH = 'SET_PERMISSIONS_FOR_SHARED_AUTH';
export const SET_DISPLAY_NAME_FOR_SHARED_AUTH = 'SET_DISPLAY_NAME_FOR_SHARED_AUTH';
export const SET_PROFILE_VALIDATIONS_FOR_SHARED_AUTH = 'SET_PROFILE_VALIDATIONS_FOR_SHARED_AUTH';
export const SET_DOB_FOR_SHARED_AUTH = 'SET_DOB_FOR_SHARED_AUTH';
export const SET_GROUP_NAME_FOR_SHARED_AUTH = 'SET_GROUP_NAME_FOR_SHARED_AUTH';
export const SET_IS_ALLOWED_FOR_SHARED_AUTH = 'SET_IS_ALLOWED_FOR_SHARED_AUTH';
export const SET_IS_VALID_TYPE_FOR_SHARED_AUTH = 'SET_IS_VALID_TYPE_FOR_SHARED_AUTH';
export const SET_MAINTENANCE_MESSAGE = 'SET_MAINTENANCE_MESSAGE';
export const SET_LOGIN_ATTEMPTED = 'SET_LOGIN_ATTEMPTED';



// WEBPACK FOOTER //
// ./src/features/shared/auth/constants.js